import { useContent } from "../../Core/Content/Provider";
import { RouteConstants } from "../../Core/Constants/RouteConstants";
import { PageHeaderPiece } from "../../Shared/Layout/Pieces";
import { ButtonPiece } from "../../Shared/UI/ButtonPiece";
import { getPortfolioHighlightsFn } from "./Functions";
import { PortfolioCardPiece } from "./Pieces";

export const PortfolioComponent = () => {
  const content = useContent("portfolio");
  const items = getPortfolioHighlightsFn();

  return (
    <section className="section-shell">
      <PageHeaderPiece
        eyebrow={content.eyebrow}
        title={content.title}
        description={content.description}
      />
      <div className="grid gap-6 lg:grid-cols-2">
        {items.map((item, index) => (
          <PortfolioCardPiece index={index} item={item} key={item.id} />
        ))}
      </div>
      <div className="mt-10 flex flex-wrap gap-3">
        <ButtonPiece appearance="secondary" to={RouteConstants.booking}>
          Book a Project
        </ButtonPiece>
        <ButtonPiece appearance="ghost" to={RouteConstants.contact}>
          Ask About Custom Work
        </ButtonPiece>
      </div>
    </section>
  );
};
